<div>
  <iui-messages id="messages" #messages  class="ms-auto me-auto"></iui-messages>
</div>
<form #form="ngForm" name="form" (ngSubmit)="submit(form)">
  <div class="mt-4 mb-4">
      <div class="row">
          <div class="col-2">
              <label for="shortCode">Short Code</label>
              <input appAlphaNumOnly appScrText required placeholder="Short Code" type="text" id="shortCode"
                  class="form-control form-text" name="shortCode" #shortCode="ngModel" maxlength="{{MaxLen.ShortCode}}" 
                  [(ngModel)]="shortCodeValue" [ngClass]="{'error-input': shortCode.errors && form.submitted}"
                  [disabled]="isInputDisabled"/>
          </div>
          <div class="col-2" style="align-self: flex-end;">
              <button class="btn btn-primary ms-3" id="suspiciousActivitySearchId" [disabled]="isSearchDisabled" >Search</button>
          </div>
      </div>
      <div class="row ps-3">
          <app-error-msg [field]="shortCode" [fieldLabel]="'Short Code'" [form]="form"></app-error-msg>
      </div>
  </div>
</form>
<div class="row" *ngIf="apiMessage">
  <div class="col-12">
      <h5>{{apiMessage}}</h5>
  </div>
  <div class="col-12">
      <a href='javascript:void(0)'
          (click)='getSCHistoy(searchShortCodeValue)'><span>View history about code {{errorDisplayShortCode}}</span>
      </a>
  </div>
</div>

<form #form1="ngForm" name="reportActivityForm" (keydown.enter)="handleEnter($event)">
  <div *ngIf="isDisplay">
 <div class="row mt-3">
      <div class="col-3 ">
        <label for="currentLesseecompanyname">Current Lessee Organization Name</label>
        <input appScrText appUppercase [(ngModel)]="model.currentLease" name="currentLease" id="currentLesseecompanyname"
           placeholder="Current Lessee Organization Name" disabled/>
      </div>
     </div>
    <div class="row mt-3">
      <div class="col-3">
        <p-checkbox [(ngModel)]="model.sharedShortCode" name="sharedShortCode" (onChange)="onChangeSharedCheckbox($event)" [binary]="true"
          id="sharedCheckbox" label="Shared Short Code"> </p-checkbox>
      </div>
    </div>
      <div class="row mt-3">
      <div class="col-3">
        <label for="contentProviderCompanyName">Content Provider Organization Name</label>
        <input appScrText [(ngModel)]="model.contentProviderCompanyName" name="contentProviderCompanyName" id="contentProviderCompanyName"
        [maxlength]="MaxLen.Company" #contentProviderCompanyName="ngModel" placeholder="Content Provider Organization Name"/>
        <app-error-msg [form]="form1" [field]="contentProviderCompanyName" fieldLabel="Content Provider Organization Name"></app-error-msg>
      </div>
    </div>
   <div class="row mt-3">
      <div class="col-md-6">
        <label class="required" for="aggregatorId">Direct Connection Aggregator Organization Name</label>
        <p-dropdown appDd [filter]="true" placeholder="Direct Connection Aggregator Organization Name"
          [options]="aggregators" optionLabel="name" optionValue="aggregatorId" name="aggregatorId" id="aggregatorId"
          #aggregatorId="ngModel" [(ngModel)]="model.aggregatorId" [required]="true"></p-dropdown>
          <app-error-msg [field]="aggregatorId" [fieldLabel]="'Direct Connection Aggregator Organization Name'" [form]="form1"></app-error-msg>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label class="required" for="applicationProviderCompanyName">Application Service Provider Organization Name</label>
        <input appScrText placeholder="Application Service Provider Organization Name" [maxlength]="MaxLen.ApplicationProvider"
           [(ngModel)]="model.applicationProviderCompanyName"
          name="applicationProviderCompanyName" id="applicationProviderCompanyName" #applicationProviderCompanyName="ngModel" required />
          <app-error-msg [field]="applicationProviderCompanyName" [fieldLabel]="'Application Service Provider Organization Name'" [form]="form1"></app-error-msg>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="brand">Brand Client Organization Name</label>
        <p-dropdown [editable]="true" appDd placeholder="Brand Client Organization Name" [maxlength]="80" [options]="brandClients" [required]="false" id="brand"
        name="brand" #brand="ngModel" [(ngModel)]="model.brand"></p-dropdown>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-3">
          <label for="activityType" class="required">Activity Type</label>
          <p-multiSelect [(ngModel)]="model.activityType" id="activityType" appTid class="p-formcontrol"
              selectedItemsLabel="{0} items selected" #role="ngModel" name="activityType"
              placeholder="Select Activity Type" [required]="true" [options]="activityTypes" optionLabel="description"
              optionValue="code" [maxSelectedLabels]="2" #activityType="ngModel">
          </p-multiSelect>
          <app-error-msg [field]="activityType" [fieldLabel]="'Activity Type'" [form]="form1"></app-error-msg>
      </div>
  </div>
    <div class="row mt-3">
      <label class="required" for="description">Description </label>
      <div class="col-9">
        <textarea rows="10" name="description" id="description" cols="30" 
          [(ngModel)]="model.description" maxlength="2000" (keyup)="onKeyup($event);" (keydown)="onKeydown($event);" class="form-control wrapper" style="width:100%" placeholder="Description of observed behavior" #description="ngModel" required 
           ></textarea>
          <app-error-msg [field]="description" [fieldLabel]="'Description'" [form]="form1"></app-error-msg>
      </div>
      <small id="descriptionLength" class="form-text text-muted">
        {{2000 - description.value?.length}} characters remaining 
      </small>
    </div>
    <div class="mt-3">
      <button (click)="reportActivity(form1)" class="btn btn-primary" id="reportActivity">Report Activity</button>
      <button type="button" class="btn btn-secondary" id="reportActivityCancelId" style="margin-left:20px;" (click)="cancel(form1)">Cancel</button>
    </div>
    </div>
</form>
